import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import posService from "../services/posService";

const initialState = {
  list: [],
  loading: false,
  error: null,
};

const posSlice = createModule({
  name: "pos",
  initialState,

  reducers: {
    /* ===== TRIGGERS ===== */
    list: (state) => {
      state.loading = true;
      state.error = null;
    },
    create: (state) => {
      state.loading = true;
      state.error = null;
    },
    update: (state) => {
      state.loading = true;
      state.error = null;
    },
    remove: (state) => {
      state.loading = true;
      state.error = null;
    },

    /* ===== RESULTS ===== */
    fetched: (state, payload) => {
      state.list = payload || [];
      state.loading = false;
    },

    finish: (state) => {
      state.loading = false;
    },

    error: (state, payload) => {
      state.loading = false;
      state.error = payload || "An error occurred";
    },
  },

  sagas: (A) => ({

    /* ===== GET ALL POS ===== */
    *[A.list]() {
      try {
        const { data } = yield call(posService.getAll);
        yield put(A.fetched(data.body || data));
      } catch (e) {
        console.error(e);
        yield put(A.error(e.message));
      }
    },

    /* ===== CREATE POS ===== */
    *[A.create]({ payload }) {
      try {
        const { data } = yield call(posService.create, payload.data);
        yield put(A.finish());
        yield put(A.list());
        payload?.onSuccess?.(data.body || data);
      } catch (e) {
        console.error(e);
        yield put(A.error(e.message));
        payload?.onError?.(e);
      }
    },

    /* ===== UPDATE POS ===== */
    *[A.update]({ payload }) {
      try {
        const { data } = yield call(
          posService.update,
          payload.id,
          payload.data
        );
        yield put(A.finish());
        yield put(A.list());
        payload?.onSuccess?.(data.body || data);
      } catch (e) {
        console.error(e);
        yield put(A.error(e.message));
        payload?.onError?.(e);
      }
    },

    /* ===== DELETE POS ===== */
    *[A.remove]({ payload }) {
      try {
        yield call(posService.delete, payload.id);
        yield put(A.finish());
        yield put(A.list());
        payload?.onSuccess?.();
      } catch (e) {
        console.error(e);
        yield put(A.error(e.message));
        payload?.onError?.(e);
      }
    },

  }),
});

export default posSlice;
export const posActions = posSlice.actions;
